quoteModule.directive('quoteDealInfo', function factory() {

    return {
        templateUrl: 'app/modules/quote/directives/quote-deal-info-directive.html',
        replace: true,
        transclude: false,
        restrict: 'E',
        controller: 'quoteDealInfoController',
        link: function(scope, element, attrs, quoteDealCtrl) {
            quoteDealCtrl.init( element );
        }
    };
});